<swiper-container
  autoplay-delay="5000"
  autoplay-pause-on-mouse-enter="true"
  [breakpoints]="breakpoints"
  class="slider-swiper"
>
  <swiper-slide *ngFor="let slide of slides">
    <div class="slider-swiper-item">
      <a [href]="slide.href">
        <picture>
          <source media="(min-width: 768px)" [attr.srcset]="slide.imgDesktop" />
          <img
            [src]="slide.imgMobile"
            [srcset]="slide.imgMobile + ' 1x, ' + slide.imgMobileBig + ' 2x'"
            sizes="100vw"
            alt="Confira nossas promoções"
            class="product-image"
            loading="eager"
            decoding="async"
          />
        </picture>
      </a>
    </div>
  </swiper-slide>
</swiper-container>
